module.exports = __webpack_public_path__ + "img/logo-akm.c5be4d38.png";